import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import { formatBankInfoDisplay } from '../../../lib/utils';

export default class ReferencesTableRow extends NavigationComponent {

    render() {
        const { displayName, position, phoneNumber, secondPhoneNumber, email, addressDisplay, isPayee, bankRoutingNumber, bankBranchNumber, bankAccountNumber, canBeDeleted} = this.props.reference;

        return (
            <tr>
                <td data-label="Name">
                    <p className="bold-text">{displayName}</p>
                </td>
                <td data-label="Position">
                    <p>{position}</p>
                </td>
                <td data-label="Phone">
                    <p>{[phoneNumber, secondPhoneNumber].filter(p => p).join(' | ')}</p>
                </td>
                <td data-label="Email">
                    <p>{email}</p>
                </td>
                <td data-label="Address">
                    <p>{addressDisplay}</p>
                </td>
                <td data-label="Payee">
                    <p>{isPayee && <i className="icon-check icon-left"></i>}</p>
                </td>
                <td data-label="BankAccount">
                    <p>{formatBankInfoDisplay(bankRoutingNumber, bankBranchNumber, bankAccountNumber) || 'N/A'} </p>
                </td>
                {this.props.canManage && <td data-label="Action">
                    <i className="icon-pencil primary-hover input" onClick={this.props.edit} style={{marginRight: "16px"}}></i>
                    {canBeDeleted && <i className="icon-trash trash-hover input" onClick={this.props.delete}></i>}
                </td>}
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/references/ReferencesTableRow.jsx